export default "__VITE_ASSET__9a49bb19__"